/**
 * Builds the RAM marketing redirect URL used to send customers from RAM Live to the Portal.
 * Query parameters match the Live Sunset campaign configuration used on RT1.
 */

const RAM_MARKETING_BASE_URL =
  "https://ram2ams.azurewebsites.net/api/RAMMarketing";

const RAM_MARKETING_CODE =
  "FZDqro1VuczY2-HPWgRzRoqwDUCfh0rMvKg9jRfrCjhYAzFu01v-tw==";

export const PORTAL_DESTINATION_URL = "https://portal.ramtracking.com";

export function buildPortalMarketingUrl(
  accountSalesforceId: string,
  userSalesforceContactId: string
): string {
  const params = new URLSearchParams({
    code: RAM_MARKETING_CODE,
    sf_campaign: "Live_Sunset_1",
    utm_medium: "Live_Sunset_Process",
    utm_campaign: "Sunset",
    utm_source: "Live",
    destinationURL: PORTAL_DESTINATION_URL,
    account_id: accountSalesforceId,
    user_id: userSalesforceContactId,
  });

  return `${RAM_MARKETING_BASE_URL}?${params.toString()}`;
}
